import React from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LoadingButton from '@mui/lab/LoadingButton';
import { useState } from "react";
import { red } from '@material-ui/core/colors';

export default function DeleteDialog(props) {
    
    const [isDisabled,setIsDisabled] = useState(false);
    const [loading, setLoading] = React.useState(false);
    function onClickDeleted(){
        setLoading(true);
        setIsDisabled(true);
        props.deleteData();
    }

    return (
        <div className="MessageDialog">
            <Dialog
                open={props.showDeleteDialog}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title" sx={{textAlign: "center" }}>
                    選択された{props.deleatItemCount}件が削除されます。
                </DialogTitle>
                    <DialogContent>
                        <DialogContentText sx={{color: red[600],textAlign: "center" }}>
                            ※削除されたデータは元に戻すことはできません。
                        </DialogContentText>
                    </DialogContent>
                <DialogActions>
                    <LoadingButton
                        onClick={()=>onClickDeleted()}
                        loading={loading}
                        disabled={isDisabled}
                    >
                        削除
                    </LoadingButton>
                    <Button autoFocus onClick={()=>props.onBack()} disabled={isDisabled}>
                        キャンセル
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
